import { render, staticRenderFns } from "./ysg.vue?vue&type=template&id=7d71aced"
import script from "./ysg.vue?vue&type=script&lang=js"
export * from "./ysg.vue?vue&type=script&lang=js"
import style0 from "./ysg.vue?vue&type=style&index=0&id=7d71aced&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports